import memoizeWith from 'ramda/es/memoizeWith'
import isEmpty from 'ramda/es/isEmpty'

const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
const _formatDate = memoizeWith(String, (value) => {
    if (!value) return ''
    if (value === '0000-00-00') return ''
    return new Date(value).toLocaleDateString('de-DE', options)
})

export const _formatDateTime = memoizeWith(String, (value) => {
    if (!value) return ''
    return new Date(value).toLocaleTimeString('de-DE', options)
})

export default {
    computed: {},

    methods: {
        formatDate(d) {
            return _formatDate(d)
        },
        formatDateTime(d) {
            return _formatDateTime(d)
        },

        secToMin(value) {
            if (!value) return 0
            return Math.round(Number(value) / 60)
        },

        formatCurrency(value, showCurrency = true) {
            if (!value) return ''
            let options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }

            if (showCurrency) {
                options.style = 'currency'
                options.currency = 'EUR'
            }

            return Number(value).toLocaleString('de-DE', options)
        },

        // Inspired by: https://gomakethings.com/how-to-truncate-text-with-vanilla-javascript/
        truncateText(value, defaultTo = '', limit = 7, after = ' ...') {
            if (!value || isEmpty( String(value).trim())) return defaultTo

            let content = String(value).trim().replace(/(\r\n|\n)/g, ' ')

            const isTruncated = (source, truncated) =>
                truncated.length < source.length
            const addAfter = (source, truncated) =>
                isTruncated(source, truncated) ? after : ''
            const truncIfToBig = (x) =>
                x.length > 55 ? x.substr(0, 45 + 10) : x
            // Remove any words above the limit
            const words = content.split(' ')
            const resultWords = truncIfToBig(
                words
                    .slice(0, limit)
                    .reduce(
                        (acc, w) =>
                            acc.join(' ').length < 45 ? acc.concat([w]) : acc,
                        []
                    )
                    .join(' ')
            )

            return resultWords + addAfter(words.join(' '), resultWords)
        },

        formatFileSize(size) {
            const calcSize = (val, div) => Math.round(val / div)

            if (size < 1000) return size + ' B'
            if (size < 1000000) return calcSize(size, 1000) + ' KB'
            if (size < 1000000000) return calcSize(size, 1000000) + ' MB'
            if (size < 1000000000000) return calcSize(size, 1000000000) + ' GB'

            return size + ' B'
        },
    },
}
